var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLongLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3811 0.713867C5.72272 0.37243 6.27673 0.372538 6.61841 0.713867C6.96012 1.05558 6.96012 1.61044 6.61841 1.95215L3.44556 5.125H10.6663C11.1495 5.125 11.5413 5.51675 11.5413 6C11.5411 6.4831 11.1494 6.875 10.6663 6.875H3.44653L6.61841 10.0479C6.96012 10.3896 6.96012 10.9434 6.61841 11.2852C6.27669 11.6267 5.72276 11.6268 5.3811 11.2852L0.714111 6.61816C0.372782 6.27648 0.372674 5.72247 0.714111 5.38086L5.3811 0.713867Z",
    fill: "#4C8BF5",
    stroke: "#4C8BF5",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongLeftArrow);
export default __webpack_public_path__ + "static/media/LongLeftArrow.ea925ae9697255f2e4731a03761ad657.svg";
export { ForwardRef as ReactComponent };